import CreateValidatedQuestionTemplate from "../templates/CreateValidatedQuestion/CreateValidatedQuestion.component";
const CreateValidatedQuestion = () => {
    return <CreateValidatedQuestionTemplate />;
};

export default CreateValidatedQuestion;
